import { defineComponent as _defineComponent } from 'vue'
import BCXUserBanner from '@/components/molecules/BCXUserBanner.vue';
import { Invitee, PAGE_SIZE_INVITEES } from '@/models/Invitation';
import InviteeStatus from '@/views/invites/InviteeStatus.vue';
import { computed, PropType } from 'vue';
import BCXTable from '@/components/BCXTable.vue';
import useI18n from '@/mixins/useI18n';
import useResponsiveness from '@/mixins/useResponsiveness';
import { getInviteeDisplayValue } from '@/views/invites/utils/inviteeDisplay';


export default /*#__PURE__*/_defineComponent({
  __name: 'InviteesTable',
  props: {
  invitees: {
    type: Array as PropType<Invitee[]>,
    default: () => []
  }
},
  setup(__props) {



const { t } = useI18n();
const { isMobileWidth } = useResponsiveness();

const fields = ['user', 'since', 'code', 'notes'];
const affiliateProgramLabel = computed(() => t('invites.invitees.note_affiliate_program'));
const headerTitles = computed(() => [
  t('invites.columns.user'),
  t('invites.columns.memberSince'),
  t('invites.columns.code'),
  t('invites.columns.notes'),
]);
const getDisplayValue = (fieldName: string, obj: Invitee) => getInviteeDisplayValue(fieldName, obj, affiliateProgramLabel.value);


return { __sfc: true,t, isMobileWidth, fields, affiliateProgramLabel, headerTitles, getDisplayValue, BCXUserBanner, PAGE_SIZE_INVITEES, InviteeStatus, BCXTable }
}

})